import styles from "./CarsPage.module.css"
import { useState, useEffect } from "react";
import HeaderPage from "../../components/HeaderPage";
import SearchBar from "../../components/SearchBar";
import FormCar from "../../components/FormCar/index.jsx";
import CarCard from "../../components/CarCard";
import MiniCardUser from "../../components/MiniCardUser";
import { deleteCar, getCars } from "../../api/cars.api.js"
import { toast } from "react-toastify";
import ModalDataCar from "../../components/ModalDataCar"
import FormEditCar from "../../components/FormEditCar/index.jsx";
import AlertDelete from "../../components/AlertDelete/index.jsx";
import { check } from "../../api/users.api.js";
import { useNavigate } from "react-router-dom";

function CarsPage() {
    const [cars, setCars] = useState([]);
    const [search, setSearch] = useState("");
    const [isOpen, setIsOpen] = useState(false)
    const [isOpenDetails, setIsOpenDetails] = useState(false)
    const [carIdSelect, setCarIdSelect] = useState("");
    const [isOpenEdit, setIsOpenEdit] = useState(false);
    const [isOpenAlert, setIsOpenDelete] = useState(false);

    const navigate = useNavigate()

    useEffect(() => {
        check()
            .then(() => {
                getCars()
                    .then(res => setCars(res.data))
                    .catch((error) => {
                        setCars([])
                        if (error.response.status === 401) {
                            return toast.error("Não autorizado!");
                        } else if (error.response.status != 200) {
                            return toast.error("Erro! Verificar com suporte");
                        }
                    });
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    navigate("/login")
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })

        getCars()
            .then(res => setCars(res.data))
            .catch((error) => {
                setCars([])
                if (error.response.status === 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            });
    }, []);

    function verDetalhes(thisEntityId) {
        setCarIdSelect(thisEntityId)
        setIsOpenDetails(true);
    }

    const entity = cars.find(car => car.id === carIdSelect)

    const filteredCars = Array.isArray(cars) ? cars.filter(car =>
        car.color?.toLowerCase().includes(search.toLowerCase()) ||
        car.placa?.toLowerCase().includes(search.toLowerCase()) ||
        car.model?.toLowerCase().includes(search.toLowerCase()) ||
        car.marca?.toLowerCase().includes(search.toLowerCase()) ||
        car.tecnico?.name?.toLowerCase().includes(search.toLowerCase())
    ) : []

    return (
        <main className={styles.container}>
            <section className={styles.containerOne}>
                <HeaderPage
                    title="Carros"
                    textTitle="Gerencie sua frota de veículos"
                    textBtn="Carro"
                    setIsOpen={() => setIsOpen(true)}
                />
                <MiniCardUser
                    text="Total de Carros"
                    data={cars.length}
                />
                <SearchBar setSearch={setSearch} />
            </section>
            <section className={styles.cards}>
                {filteredCars.map(car => {
                    return <CarCard thisCar={car} key={car.id} verDetalhes={verDetalhes} />
                })}
            </section>


            {isOpen && (
                <FormCar setIsOpen={setIsOpen} setCars={setCars} cars={cars} />
            )}

            {isOpenDetails && (
                <ModalDataCar setIsOpen={setIsOpenDetails} thisCar={entity} setIsOpenEdit={setIsOpenEdit} setIsOpenDelete={setIsOpenDelete} />
            )}

            {isOpenEdit && (
                <FormEditCar entity={entity} setIsOpen={setIsOpenEdit} />
            )}

            {isOpenAlert && (
                <AlertDelete entity={entity} setIsOpen={setIsOpenDelete} func={deleteCar} />
            )}
        </main>
    )
}

export default CarsPage;